export type AdminOrderItem = {
  id: number;
  quantity: number;
  unitPrice: number;
  total: number;
  productId: number | null;
  name: string;
  slug: string | null;
};

export type AdminOrderSummary = {
  id: number;
  total: number;
  discount: number;
  amountPaid: number;
  balance: number;
  status: string;
  addedOn: string | null;
  trackingNumber: string;
  paymentType: string;
  orderSource: string;
  deliveryName: string;
  deliveryPhone: string;
  deliveryAddress: string;
  email: string;
  deliveryNote: string;
  buyerPhone: string;
  itemCount: number;
};

export type AdminOrdersResponse = {
  orders: AdminOrderSummary[];
  pagination: {
    page: number;
    pageSize: number;
    totalOrders: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
  summary: {
    totalOrders: number;
    pendingOrders: number;
    paidOrders: number;
    revenueTotal: number;
  };
};

export type AdminOrderDetail = AdminOrderSummary & {
  items: AdminOrderItem[];
};

export type AdminOrderUpdateInput = {
  status: "Pending" | "Paid" | "Processing" | "Delivered" | "Cancelled";
  trackingNumber?: string;
  amountPaid: number;
  paymentType?: "" | "MPESA" | "CASH" | "CHEQUE" | "BANK_TRANSFER";
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function fetchAdminOrders(query: URLSearchParams) {
  const response = await fetch(`/api/admin/orders?${query.toString()}`, {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as AdminOrdersResponse;
}

export async function fetchAdminOrder(orderId: number) {
  const response = await fetch(`/api/admin/orders/${orderId}`, {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as AdminOrderDetail;
}

export async function updateAdminOrder(orderId: number, input: AdminOrderUpdateInput) {
  const response = await fetch(`/api/admin/orders/${orderId}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(input)
  });

  return parseResponse(response);
}
